export default __webpack_public_path__ + "static/fall31-0d65bb10366c229cad79af0f8c586966.webp";